import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
@Component({
  selector: 'app-reportcard-exam-wise',
  templateUrl: './reportcard-exam-wise.component.html',
  styleUrls: ['./reportcard-exam-wise.component.css']
})
export class ReportcardExamWiseComponent implements OnInit {

  StudentID = '0';
  ClassID = 0;
  PrintType = '';
  SectionID = 0;
  TermID = 0;
  TermName = 'Annual';
  ScoreCardTypeID = 0;
  ExamMapID = 0;
  SessionID = 0;

  constructor(private activatedRoute: ActivatedRoute, private examService: ExamService, private lookupService: LookupService, public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) {

    this.activatedRoute.queryParams.subscribe(params => {

      this.StudentID = params['StudentID'];
      this.ClassID = params['ClassID'];
      this.PrintType = params['PrintType'];
      this.SectionID = params['SectionID'];
      this.TermID = params['TermID'];
      this.ScoreCardTypeID = params['ScoreCardTypeID'];
      this.ExamMapID = params['ExamMapID'];
      this.SessionID = params['SessionID'];


      this.GetExamStudentScoreCard()
    });

  }

  StudentReport :any;
  ScoreCardModel = {
    ClassID: 0,
    StudentIDs: "",
    SectionID: 0,
    ScoreCardTypeID: 0,
    TermID: 0,
    ExamMapID: 0,
    SessionID:0,

  };
  printdate = "";
  GetExamStudentScoreCard() {
    this.StudentReport = [];
  
    
      this.ScoreCardModel = {
        ClassID: this.ClassID,
        StudentIDs: this.StudentID,
        SectionID: this.SectionID,
        ScoreCardTypeID: this.ScoreCardTypeID,
        TermID: this.TermID,
        ExamMapID: this.ExamMapID,
        SessionID: this.SessionID,

      };

      this.examService.GetExamStudentScoreCardExamWise(JSON.stringify(this.ScoreCardModel)).subscribe((data) => {
      
        this.StudentReport= data;
        this.StudentReport.StubjectMarks= data.StubjectMarks;
        this.StudentReport.HeaderDetails= data.HeaderDetails;
        setTimeout(() => {
          window.print();
        }, 300);

      });
    

  }

  ngOnInit() {
  }

}
